import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import {useReportsManager} from '@ui/ReportModal/hooks/useReportsManager';
import dayjs from 'dayjs';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {DT_FORMATS, formatDate} from 'utils';

type UserReportModalProps = {
    onClose: () => void;
};

export const UserReportModal = ({onClose}: UserReportModalProps) => {
    const {t} = useTranslation('header');
    const {startReport} = useReportsManager();
    const [values, setValues] = useState({
        dateFrom: '',
        dateTo: '',
    });

    const downloadUserReport = async () => {
        await startReport(
            'user-login-report',
            {},
            {dateFrom: values.dateFrom, dateTo: values.dateTo},
        );
        setValues({dateFrom: '', dateTo: ''});
        onClose();
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
        >
            <DialogTitle>{t('userReport')}</DialogTitle>
            <DialogContent sx={{width: '435px'}}>
                <Typography
                    variant='subtitle1'
                    mb={1}
                >
                    {t('userReportDescription')}
                </Typography>
                <Stack
                    direction='row'
                    gap={1}
                >
                    <DesktopDatePicker
                        value={values.dateFrom ? dayjs(values.dateFrom) : null}
                        onChange={(value) =>
                            setValues((prev) => ({
                                ...prev,
                                dateFrom: formatDate(value, `${DT_FORMATS.utcFull}`),
                            }))
                        }
                        label={t('pretext.from')}
                        format={DT_FORMATS.defaultDate}
                        slotProps={{
                            textField: {
                                size: 'small',
                            },
                        }}
                    />
                    <DesktopDatePicker
                        value={values.dateTo ? dayjs(values.dateTo) : null}
                        onChange={(value) =>
                            setValues((prev) => ({
                                ...prev,
                                dateTo: formatDate(
                                    dayjs(value).endOf('day'),
                                    `${DT_FORMATS.utcFull}`,
                                ),
                            }))
                        }
                        disabled={!values.dateFrom} // Блокирует выбор даты, если dateFrom не выбрана
                        minDate={values.dateFrom ? dayjs(values.dateFrom) : undefined} // Блокирует даты раньше dateFrom
                        label={t('pretext.to')}
                        slotProps={{
                            textField: {
                                size: 'small',
                            },
                        }}
                        format={DT_FORMATS.defaultDate}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button
                    variant='contained'
                    onClick={downloadUserReport}
                    disabled={
                        !values.dateFrom ||
                        !values.dateTo ||
                        dayjs(values.dateFrom).isAfter(dayjs(values.dateTo)) ||
                        dayjs(values.dateTo).isAfter(dayjs('2099-12-31')) ||
                        dayjs(values.dateTo).isBefore(dayjs('1900-01-01'))
                    }
                >
                    {t('download')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
